import { render, staticRenderFns } from "./Faq-modal.vue?vue&type=template&id=ddf01bbc&scoped=true&"
import script from "./Faq-modal.vue?vue&type=script&lang=ts&"
export * from "./Faq-modal.vue?vue&type=script&lang=ts&"
import style0 from "./Faq-modal.vue?vue&type=style&index=0&id=ddf01bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf01bbc",
  null
  
)

export default component.exports